/**
 * TJBC Custom JavaScript — Horizon Theme
 * ─────────────────────────────────────────────────────────────────────────────
 * Horizon handles both predictive search (header typeahead) and full search
 * results (with filters, sorting, infinite scroll) natively via web components.
 * This file contains only TJBC-specific integrations that Horizon does not
 * cover: Affirm widget refresh, Bold Upsell deduplication, Judge.me styling,
 * and responsive homepage banner visibility.
 *
 * No jQuery dependency — uses native DOM APIs throughout.
 * ─────────────────────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  // ───────────────────────────────────────────────────────────────────────────
  // AFFIRM — widget style fixes and variant price refresh
  // ───────────────────────────────────────────────────────────────────────────

  // Correct Affirm's injected font-size
  document.querySelectorAll('.affirm-as-low-as').forEach(function (el) {
    el.style.fontSize = '12px';
  });

  // Gold colour on the "Learn more" link Affirm injects asynchronously
  setTimeout(function () {
    document.querySelectorAll('.affirm-modal-trigger').forEach(function (el) {
      el.style.setProperty('color', '#b2873d', 'important');
    });
  }, 3000);

  // Refresh Affirm data-amount when the shopper picks a different variant.
  // Horizon fires a custom 'variant:change' event on <variant-picker>.
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    var affirmEl = document.querySelector('#affirmlow .affirm-as-low-as');
    if (affirmEl) {
      affirmEl.setAttribute('data-amount', variant.price);
      if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) {
        window.affirm.ui.refresh();
      }
    }
  });

  // ───────────────────────────────────────────────────────────────────────────
  // JUDGE.ME — force white text on action buttons
  // ───────────────────────────────────────────────────────────────────────────

  document.querySelectorAll('.jdgm-btn, .jdgm-rev__reply').forEach(function (el) {
    el.style.setProperty('color', 'white', 'important');
  });

  // ───────────────────────────────────────────────────────────────────────────
  // RESPONSIVE HOMEPAGE BANNER VISIBILITY
  // ───────────────────────────────────────────────────────────────────────────

  function checkBannerSize() {
    if (window.location.pathname !== '/') return;

    var isMobile = window.innerWidth <= 574;

    document.querySelectorAll('.simple-banner-desktop, .desktop-carousel').forEach(function (el) {
      el.style.display = isMobile ? 'none' : '';
    });

    document.querySelectorAll('.simple-banner-mobile, .mobile-carousel').forEach(function (el) {
      el.style.display = isMobile ? '' : 'none';
    });
  }

  checkBannerSize();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkBannerSize, 100);
  });

  // ───────────────────────────────────────────────────────────────────────────
  // BOLD UPSELL — sticky bar duplicate element cleanup
  //
  // Bold Upsell injects cloned ATC buttons into [data-product-form].
  // If multiple are injected, keep only the one with the lowest
  // data-event-queue-button value and remove the rest.
  // ───────────────────────────────────────────────────────────────────────────

  var boldTarget = document.querySelector('[data-product-form]');
  if (boldTarget) {
    function deduplicateBoldElements(className) {
      var elems = boldTarget.querySelectorAll(className);
      if (elems.length <= 1) return;

      var minEl  = null;
      var minVal = Infinity;

      elems.forEach(function (el) {
        var v = parseInt(el.getAttribute('data-event-queue-button'), 10);
        if (!isNaN(v) && v < minVal) {
          minVal = v;
          minEl  = el;
        }
      });

      elems.forEach(function (el) {
        if (el !== minEl) {
          el.remove();
        } else {
          el.style.opacity = '1';
          el.setAttribute('data-event-queue-button', '1');
        }
      });
    }

    var boldDebounce;
    var boldObserver = new MutationObserver(function () {
      clearTimeout(boldDebounce);
      boldDebounce = setTimeout(function () {
        deduplicateBoldElements('.bold_clone');
        deduplicateBoldElements('.bold_hidden');
      }, 50);
    });

    boldObserver.observe(boldTarget, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

})();
